import { getAdvancedUrl } from 'app/developer-v3/utils';
import type { SemVer } from 'app/developer-v3/types/version';

type GetNavOptions = {
  appId: string;
  version: SemVer;
  hasLegacy: boolean;
  isStaff: boolean;
  isGUIIntegration: boolean;
};

export const getNav = ({
  appId,
  version,
  hasLegacy,
  isStaff,
  isGUIIntegration,
}: GetNavOptions) => {
  const baseUrl = getAdvancedUrl(appId, version);
  const items = [
    { text: 'Environment', href: `${baseUrl}/environment` },
    {
      text: 'Request Template',
      href: `${baseUrl}/request-template`,
      disabled: !isGUIIntegration,
    },
  ];

  if (isStaff) {
    items.push({
      text: 'Middleware',
      href: `${baseUrl}/middleware`,
      disabled: !isGUIIntegration,
    });
  }

  if (hasLegacy) {
    items.push({
      text: 'Legacy Web Builder',
      href: `${baseUrl}/legacy`,
      disabled: !isGUIIntegration,
    });
  }

  items.push({
    text: 'Export Project',
    href: `${baseUrl}/export`,
    disabled: !isGUIIntegration,
  });

  items.push({
    text: 'View Source',
    href: `${baseUrl}/source`,
    disabled: false,
  });

  items.push({
    text: 'Settings',
    href: `${baseUrl}/settings`,
    disabled: false,
  });

  return items;
};
